import React from 'react';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { statisticsReports as StatisticsReportsView } from 'ui/views/widgets/statisticsReports';
import { StatisticsReportsService } from 'services/statisticsReports';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { StatisticsReports } from 'ui/containers/StatisticsReports';
 *
 * // render
 * <StatisticsReports propName='propValue'/>
 */
export class StatisticsReports extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.statisticsReportsService = new StatisticsReportsService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'StatisticsReports.fetchComponentData()' );

        // cancel ongoing request
        this.statisticsReportsService.cancel();

        // get status and service data
        const { status, data } = await this.statisticsReportsService.fetchComponentData( {
            url: this.props.widget.url
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unMounts, cleanup resources.
     */
    componentWillUnmount() {
        this.statisticsReportsService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <StatisticsReportsView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
StatisticsReports.displayName = 'StatisticsReports';

// set default props
StatisticsReports.defaultProps = {};

// prop types
StatisticsReports.propTypes = {};
